
export const requestUserLocation = (callback) => {
    if (!navigator.geolocation) {
        callback(null);
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (position) => {
            callback({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            });
        },
        (error) => {
            console.log("Geolocation error or permission denied:", error);
            callback(null);
        }
    );
};


export const getDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};

export const sortGroupedVenuesByDistance = (venues = []) => {
    if (!Array.isArray(venues)) return [];

    return [...venues].sort((a, b) => {
        const distA = typeof a.venue_distance === "number"
            ? a.venue_distance
            : parseFloat(a.venue_distance) || Infinity;
        const distB = typeof b.venue_distance === "number"
            ? b.venue_distance
            : parseFloat(b.venue_distance) || Infinity;
        return distA - distB;
    });
};

